function readField(raw: Record<string, unknown>, key: string): unknown {
  const nested = raw.payload;
  if (nested !== null && typeof nested === 'object' && key in nested) {
    return (nested as Record<string, unknown>)[key];
  }
  return raw[key];
}

function readString(raw: Record<string, unknown>, key: string): string {
  const value = readField(raw, key);
  return typeof value === 'string' ? value : '';
}

function readNumber(raw: Record<string, unknown>, key: string): number {
  const value = readField(raw, key);
  if (typeof value === 'bigint') return Number(value);
  return typeof value === 'number' && Number.isFinite(value) ? value : 0;
}

function readOutcomeIndex(raw: Record<string, unknown>): number | null {
  const value = readField(raw, 'outcomeIndex');
  const index = typeof value === 'bigint' ? Number(value) : value;
  return typeof index === 'number' && Number.isInteger(index) && index >= 0 && index < 10
    ? index
    : null;
}

export function applyOutcomePromotion<
  Row extends {
    readonly id?: string;
    readonly status?: string;
    readonly promotedOutcomePubkey?: string | null;
    readonly outcomeIndex?: number | null;
    readonly promotedAt?: string | null;
  },
>(prev: Row, raw: Record<string, unknown>, _args?: Record<string, unknown>): Row {
  const suggestionId = readString(raw, 'suggestionId');
  if (suggestionId.length === 0 || prev.id !== suggestionId) return prev;

  const outcomePubkey = readString(raw, 'outcomePubkey');
  const outcomeIndex = readOutcomeIndex(raw);
  const ts = readNumber(raw, 'ts');
  const promotedAt = ts > 0 ? new Date(ts).toISOString() : null;
  return {
    ...prev,
    status: 'promoted',
    promotedOutcomePubkey: outcomePubkey || prev.promotedOutcomePubkey,
    outcomeIndex: outcomeIndex ?? prev.outcomeIndex ?? null,
    promotedAt: promotedAt ?? prev.promotedAt ?? null,
  };
}
